<span class="loading" *ngIf="loading">
    <i class="fa fa-spinner fa-spin" style="font-size:40px;color:white"></i>
</span>

<router-outlet></router-outlet>